import { Platform } from 'react-native';
import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: `${Platform.OS === 'web' ? 'fixed' : 'absolute'} bottom-0 left-0 right-0 bg-neutral10 lg:w-[20rem] lg:top-0 lg:right-auto lg:h-full lg:py-2xl lg:border-r lg:border-neutral20 lg:bg-[transparent]`,
  userLink: 'px-xl mb-xl hidden lg:flex overflow-hidden',
  user: 'max-w-full',
  nav: 'min-h-[6.4rem] pt-xs lg:pt-0 flex-row lg:flex-col lg:items-start',
  logo: 'hidden lg:flex px-xl pb-2xl mt-auto',
  trigger:
    'min-h-[5.2rem] flex-1 lg:py-md flex-col lg:flex-row lg:px-xl lg:justify-start lg:w-full items-center justify-center gap-sm',
  triggerDot:
    'absolute top-1/2 -left-[0.5rem] -translate-y-1/2 w-[1rem] h-[1rem] rounded-full bg-accentSecondary40 hidden lg:flex',
  triggerLabel: tv({
    base: 'text-[1.2rem] leading-[1] lg:text-sm lg:leading-[1.4] lg:text-neutral20',
    variants: {
      focused: {
        true: 'text-accentSecondary10 lg:font-F37Bold lg:text-neutral30',
        false: 'text-neutral30',
      },
    },
  }),
  notification:
    'absolute bottom-xs h-xs w-xs rounded-full bg-accentSecondary40 lg:relative lg:bottom-auto',
};
